import { defineMessages } from "react-intl";
const messages = defineMessages({
    skippedStatus: {
        id: "app.scanRequests.table.status.skipped",
        defaultMessage: "Skipped",
    },
    canceledStatus: {
        id: "app.scanRequests.table.status.canceled",
        defaultMessage: "Canceled",
    },
    scheduledStatus: {
        id: "app.scanRequests.table.status.scheduled",
        defaultMessage: "Scheduled",
    },
    requestedStatus: {
        id: "app.scanRequests.table.status.requested",
        defaultMessage: "Requested",
    },
});
export default messages;
